<h2 mat-dialog-title>IBN-Protokoll exportieren</h2>

<mat-dialog-content class="dialog-content">

  <p class="intro">
    Wofür soll das Protokoll erstellt werden?
  </p>

  <div class="umfang-liste">

    <button type="button" class="umfang-option" [class.aktiv]="umfang === 'projekt'" (click)="waehleUmfang('projekt')">
      <mat-icon>folder_open</mat-icon>
      <span class="umfang-text">
        <span class="umfang-titel">Ganzes Projekt</span>
        <span class="umfang-sub">
          {{ data.projekt.name }} · {{ data.projekt.inbetriebnahmenCount }} Inbetriebnahme{{
          data.projekt.inbetriebnahmenCount === 1 ? '' : 'n' }}
          · {{ data.projekt.messstellenGesamt }} Messstellen
        </span>
      </span>
      <mat-icon class="haken" *ngIf="umfang === 'projekt'">check_circle</mat-icon>
    </button>

    <button type="button" class="umfang-option" [class.aktiv]="umfang === 'inbetriebnahme'"
      [disabled]="!hatInbetriebnahmen" (click)="waehleUmfang('inbetriebnahme')">
      <mat-icon>playlist_add_check</mat-icon>
      <span class="umfang-text">
        <span class="umfang-titel">Eine Inbetriebnahme</span>
        <span class="umfang-sub">Alle Messstellen einer Messstellenliste.</span>
      </span>
      <mat-icon class="haken" *ngIf="umfang === 'inbetriebnahme'">check_circle</mat-icon>
    </button>

    <button type="button" class="umfang-option" [class.aktiv]="umfang === 'messstelle'" [disabled]="!hatInbetriebnahmen"
      (click)="waehleUmfang('messstelle')">
      <mat-icon>sensors</mat-icon>
      <span class="umfang-text">
        <span class="umfang-titel">Messstellen detailliert</span>
        <span class="umfang-sub">
          Mit allen Prüfpunkten und dem vollständigen Prüfverlauf – einzeln oder für mehrere Messstellen.
        </span>
      </span>
      <mat-icon class="haken" *ngIf="umfang === 'messstelle'">check_circle</mat-icon>
    </button>

  </div>

  <p class="hinweis" *ngIf="!hatInbetriebnahmen">
    <mat-icon>info_outline</mat-icon>
    Diesem Projekt ist noch keine Inbetriebnahme zugeordnet – es lässt sich nur
    das Projekt selbst exportieren.
  </p>


  <!-- Auswahl der Inbetriebnahme: nur beim Umfang „Eine Inbetriebnahme“.
       Bei den Messstellen-Varianten wird sie im Folgedialog gewählt. -->
  <mat-form-field appearance="outline" class="auswahl" *ngIf="umfang === 'inbetriebnahme'">
    <mat-label>Inbetriebnahme</mat-label>
    <mat-select [value]="inbetriebnahmeId" (selectionChange)="onInbetriebnahmeChange($event.value)">
      <mat-option *ngFor="let inb of inbetriebnahmen" [value]="inb.id">
        {{ inb.name }} ({{ inb.messstellenCount }} Messstellen)
      </mat-option>
    </mat-select>
  </mat-form-field>


  <!-- Die drei Varianten für Messstellen -->
  <div class="varianten" *ngIf="umfang === 'messstelle'">

    <p class="varianten-titel">Wie sollen die Messstellen ausgegeben werden?</p>

    <button type="button" class="umfang-option variante-option" [class.aktiv]="variante === 'einzeln'"
      (click)="waehleVariante('einzeln')">
      <mat-icon>description</mat-icon>
      <span class="umfang-text">
        <span class="umfang-titel">Eine Messstelle</span>
        <span class="umfang-sub">Ein vollständiges PDF für eine einzelne Messstelle.</span>
      </span>
      <mat-icon class="haken" *ngIf="variante === 'einzeln'">check_circle</mat-icon>
    </button>

    <button type="button" class="umfang-option variante-option" [class.aktiv]="variante === 'combinedPdf'"
      (click)="waehleVariante('combinedPdf')">
      <mat-icon>library_books</mat-icon>
      <span class="umfang-text">
        <span class="umfang-titel">Mehrere Messstellen in einem PDF</span>
        <span class="umfang-sub">
          Projekt- und IBN-Daten einmal am Anfang, danach jede Messstelle auf einer eigenen Seite.
        </span>
      </span>
      <mat-icon class="haken" *ngIf="variante === 'combinedPdf'">check_circle</mat-icon>
    </button>

    <button type="button" class="umfang-option variante-option" [class.aktiv]="variante === 'zip'"
      (click)="waehleVariante('zip')">
      <mat-icon>folder_zip</mat-icon>
      <span class="umfang-text">
        <span class="umfang-titel">Mehrere Messstellen als einzelne PDFs im ZIP</span>
        <span class="umfang-sub">Je Messstelle ein eigenes PDF, gemeinsam in einer ZIP-Datei.</span>
      </span>
      <mat-icon class="haken" *ngIf="variante === 'zip'">check_circle</mat-icon>
    </button>

  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="abbrechen()">Abbrechen</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!istGueltig" (click)="exportieren()">
    <mat-icon>{{ istWeiter ? 'arrow_forward' : 'picture_as_pdf' }}</mat-icon>
    {{ istWeiter ? 'Weiter' : 'PDF erstellen' }}
  </button>
</mat-dialog-actions>
